import { render, staticRenderFns } from "./approvalRVT.vue?vue&type=template&id=44e3519a&scoped=true"
import script from "./approvalRVT.vue?vue&type=script&lang=js"
export * from "./approvalRVT.vue?vue&type=script&lang=js"
import style0 from "./approvalRVT.vue?vue&type=style&index=0&id=44e3519a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e3519a",
  null
  
)

export default component.exports